import React, { useState } from "react";

const EmailModal = ({
  closeEmailPopup,
  emailSent,
  handleSendEmail,
  emailInput,
  handleEmailInput,
  likedNames,
  emailError,
  setLiked,
  handleRemoveLiked,
}) => {
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    try {
      await handleSendEmail(e);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box modal-margins">
        <button className="popup-close" onClick={closeEmailPopup}>
          &times;
        </button>
        <h2>Email Liked Names</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label htmlFor="email-input">Recipient Email:</label>
            <input
              id="email-input"
              type="email"
              value={emailInput}
              onChange={handleEmailInput}
              style={{
                width: "100%",
                padding: "0.5rem",
                borderRadius: 8,
                border: "1px solid #ddd",
                marginTop: 4,
              }}
              required
            />
            {emailError && (
              <div style={{ color: "#e11d48", marginTop: 4 }}>{emailError}</div>
            )}
          </div>
          <div style={{ marginBottom: 12 }}>
            <b>Names to send:</b>
            {likedNames.length === 0 ? (
              <div style={{ fontStyle: "italic", color: "#6b7280" }}>
                No names selected.
              </div>
            ) : (
              <ul
                style={{
                  margin: "0.5rem 0 0 0",
                  padding: 0,
                  listStyle: "none",
                }}
              >
                {likedNames.map((n) => (
                  <li
                    key={n._id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0.3rem 0",
                    }}
                  >
                    {n.eng_word}
                    <button
                      type="button"
                      onClick={() => handleRemoveLiked(n._id)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#ef4444",
                        fontSize: "1.1em",
                        padding: "0 0.5rem",
                      }}
                      aria-label={`Remove ${n.eng_word}`}
                    >
                      🗑️
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          {/* Button container for Send Email and Clear All */}
          <div style={{ display: "flex", gap: "10px", marginTop: 20 }}>
            <button
              type="submit"
              className="reset-btn email-modal-send-btn"
              style={
                !emailInput ||
                emailError ||
                likedNames.length === 0 ||
                isSending
                  ? { opacity: 0.7, cursor: "not-allowed", flex: 1 }
                  : { flex: 1 }
              }
              disabled={
                !emailInput ||
                emailError ||
                likedNames.length === 0 ||
                isSending
              }
            >
              {isSending ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <div className="button-spinner"></div>
                  <span>Sending...</span>
                </div>
              ) : (
                <span>Send Email</span>
              )}
            </button>
            {/* Clear All Liked Names text link */}
            {likedNames.length > 0 && !emailSent && !isSending && (
              <span
                className="clear-liked-link"
                onClick={() => setLiked([])}
                style={{
                  color: "#e11d48",
                  textDecoration: "underline",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                  fontSize: "0.9em",
                }}
              >
                Clear All
              </span>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailModal;
